module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("剩餘數量: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.residual))])]), _vm._v(" "), (!_vm.allowToNext) ? _c('h6', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.warnMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn  btn-lg confirm-button",
    attrs: {
      "disabled": !_vm.allowToNext
    },
    on: {
      "click": _vm.goOn
    }
  }, [_vm._v("繼續動作")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-389f5d16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/ActionBreak.vue
// module id = 1435
// module chunks = 1